import React, { Component } from "react";
import { fire } from "../Firebase/firebase";
import { Link, Redirect } from "react-router-dom";

class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      favUsers: [],
      ballsCaught: []
    };
    this.goBack = this.goBack.bind(this);
  }


  goBack() {
    this.props.history.goBack();
  }

  logOut(e) {
    fire.auth().signOut();
  }

  render() {
    if (this.props.authenticated === false) {
      return <Redirect to="/" />;
    }

    return (
      <div className="container">
        <i onClick={this.goBack} className="arrow left" />
        <div className="d-inline ">
          <div id="profile-title">{this.props.location.state.user.name}</div>
          <div className="profile-page-info">
            <img
              alt="dog profile"
              id="avatar-profile"
              src={this.props.location.state.user.avatar}
            />
            
              <div id="profile-visibility">
                {this.props.location.state.user.visibility
                  ? "Visible"
                  : "Not visible"}
              </div>
            
            <div className="profile-links">
              <div className="profile-card">
                <Link
                  to={{
                    pathname: "./favourite_users",
                    state: {
                      user: this.props.location.state.user,
                      favUsers: this.state.favUsers
                    }
                  }}
                >
                  Favourited dogs
                </Link>
              </div>

              <div className="profile-card">
                <Link
                  to={{
                    pathname: "./balls_caught",
                    state: {
                      user: this.props.location.state.user,
                      ballsCaught: this.state.ballsCaught,
                     
                    }
                  }}
                >
                  Balls caught today
                </Link>
              </div>

              <span
                onClick={this.logOut}
                style={{
                  float: "left",
                  marginTop: 10,
                  marginLeft: 10,
                  fontFamily: "Helvetica Neue",
                  color: "#4A4A4A"
                }}
              >
                Log Out
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Profile;
